<main class="flex justify-center items-center h-full">
  <div class="flex justify-center flex-wrap px-[60px] py-[36px] sm:px-0 sm:py-0">
    <div class="flex justify-center items-center flex-col sm:mr-10">
      <h2 class="text-9xl text-purple-800">404</h2>
    </div>
    <div
      class="flex flex-col items-center sm:items-start justify-center max-w-[350px]">
      <p class="text-2xl leading-none font-bold mb-2.5">
        Упс, что-то пошло не так...
      </p>
      <p class="text-lg mb-2.5 leading-1 text-center sm:text-left">
        К сожалению, запрашиваемая Вами страница перемещена или удалена, а,
        возможно, её никогда не было.
      </p>
      <a href="/" target="_blank" class="!text-primary !text-lg noBorderLink"
      >Перейти на главную страницу</a
      >
    </div>
  </div>
</main>
